"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var camelize_style_1 = require("./util/camelize-style");
var hyphenate_style_1 = require("./util/hyphenate-style");
var _1 = require("../_");
function getCss(node, property) {
    return node.style[camelize_style_1.camelizeStyle(property)]
        || getComputedStyle(node).getPropertyValue(hyphenate_style_1.hyphenateStyle(property));
}
exports.getCss = getCss;
function setCss(node, property, value) {
    if (!value && value !== 0) {
        removeStyle(node, hyphenate_style_1.hyphenateStyle(property));
    }
    else {
        node.style.cssText += ';' + hyphenate_style_1.hyphenateStyle(property) + ':' + value;
    }
}
exports.setCss = setCss;
function setStyle(node, props) {
    var css = '';
    for (var key in props)
        if (_1.has(props, key)) {
            !props[key] && props[key] !== 0
                ? removeStyle(node, hyphenate_style_1.hyphenateStyle(key))
                : (css += hyphenate_style_1.hyphenateStyle(key) + ':' + props[key] + ';');
        }
    node.style.cssText += ';' + css;
    return css;
}
exports.setStyle = setStyle;
function getComputedStyle(node) {
    var doc = node.ownerDocument;
    if (!('defaultView' in doc)) {
        throw new Error('IE8 is not supported');
    }
    if (doc.defaultView.opener) {
        return node.ownerDocument.defaultView.getComputedStyle(node);
    }
    else {
        return window.getComputedStyle(node);
    }
}
exports.getComputedStyle = getComputedStyle;
function removeStyle(node, key) {
    if ('removeProperty' in node.style) {
        node.style.removeProperty(key);
    }
    else {
        node.style['removeAttribute'](key);
    }
}
exports.removeStyle = removeStyle;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/style.js
// module id = 93
// module chunks = 0 1 2 3 4 5 6